import {
  IconButton,
  IconButtonProps,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { useConfirm } from 'material-ui-confirm';
import { useSnackbar } from 'notistack';

import { useAppDispatch } from 'store';
import {
  fetchCancelarTransferencia,
  updateListaDeIniciadosCancelarTransferencia,
} from 'store/reducers/atendimentos';

const useStyles = makeStyles(() => ({
  animateButtonContainer: {
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },

  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

type ButtonCancelarTransferencia = IconButtonProps & {
  transferenciaPendenteId: string;
  atendimentoId?: string;
};

export default function ButtonCancelarTransferencia(
  props: ButtonCancelarTransferencia,
) {
  const { transferenciaPendenteId, atendimentoId, ...rest } = props;
  const confirm = useConfirm();
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const handleCancelarTransferencia = () => {
    if (transferenciaPendenteId) {
      confirm({
        title: <Typography variant="body2">Cancelar transferência</Typography>,
        description: (
          <Typography variant="caption">
            Deseja cancelar esta transferência?
          </Typography>
        ),
        cancellationText: 'Não',
        confirmationText: 'Ok',
        confirmationButtonProps: { variant: 'contained', color: 'secondary' },
        dialogProps: { maxWidth: 'xs' },
      })
        .then(() => {
          dispatch(fetchCancelarTransferencia(transferenciaPendenteId))
            .unwrap()
            .then(({ message }) => {
              if (atendimentoId) {
                dispatch(
                  updateListaDeIniciadosCancelarTransferencia({
                    atendimentoId,
                  }),
                );
              }
              if (message) enqueueSnackbar(message);
            });
        })
        .catch(() => {
          //
        });
    }
  };

  return (
    <Tooltip title="Cancelar Transferência">
      <IconButton
        {...rest}
        className={classes.animateButtonContainer}
        onClick={e => {
          e.stopPropagation();
          handleCancelarTransferencia();
        }}
        color="secondary"
      >
        <SwapHorizIcon />
      </IconButton>
    </Tooltip>
  );
}
